import ThreeDCheckout from './Checkout';
import ThreeDPayment from './Payment';
import ThreeDTip from './Tip';

export default {
  ThreeDCheckout,
  ThreeDPayment,
  ThreeDTip,
};
